import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwitchHorizontal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 6.6665L14 4.6665M14 4.6665L12 2.6665M14 4.6665H4.66667M4 9.33317L2 11.3332M2 11.3332L4 13.3332M2 11.3332H11.3333",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSwitchHorizontal;
